<template>
  <AppSection
    id="import-settings"
    :title="$getConst.pages.import_settings.import_settings_title"
    type="section"
  >
    <router-view></router-view>
  </AppSection>
</template>

<script>
    import AppSection from "../../../../components/common/sections/AppSection";
    export default {
        name: "index",
      components: {AppSection}
    }
</script>
